module.exports = __webpack_public_path__ + "static/media/product30.700b805b.jpg";